<template>
    <div class="ng-content-wrap">
        <NgongVegBanner />
        <div class="ng-block-head ng-block-head-lg">
            <!-- Block head -->
            <div class="ng-block-head-sub d-print-none">
                <router-link class="back-to" to="/">
                    <em class="icon ni ni-chevron-left-c mr-1"></em>
                    <span>Dashboard</span>
                </router-link>
            </div>
            <!-- Block head -->

            <!-- Block head -->
            <div class="ng-block-between-md g-4">
                <div class="ng-block-head-content">
                    <h2 class="ng-block-title fw-normal">
                        {{ $route.meta.title }}
                    </h2>
                    <div class="ng-block-des d-print-none">
                        <p>
                            Manage brands.
                        </p>
                    </div>
                </div>
                
                <div class="ng-block-head-content">
                    <ul class="ng-block-tools gx-3 d-print-none">
                        <li>
                            <div class="form-group">
                                <input
                                type="text"
                                class="form-control"
                                placeholder="Type to search..."
                                v-model="search"
                                @keyup="searchRecords"
                                />
                            </div>
                        </li>
                        <li>
                            <a
                                href="#newItem"
                                data-toggle="modal"
                                class="btn btn-white btn-dim btn-outline-primary"
                            >
                                <em class="icon ni ni-plus-c"></em>
                                <span>
                                    <span class="d-none d-sm-inline-block"> Add </span> New
                                </span>
                            </a>

                            <!-- Modal -->
                            <div class="modal fade" tabindex="-1" id="newItem">
                                <div class="modal-dialog" role="document">
                                    <form class="modal-content" @submit.prevent="createRecord">
                                        <button
                                            id="hideNewForm"
                                            class="close"
                                            data-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            <em class="icon ni ni-cross text-white"></em>
                                        </button>

                                        <div class="modal-header bg-primary">
                                            <h5 class="modal-title text-white" v-if="record.name">
                                                Adding {{ record.name }}
                                            </h5>
                                            <h5 class="modal-title text-white" v-else>
                                                Add New Brand
                                            </h5>
                                        </div>

                                        <div class="modal-body form row">
                                            <div class="row" v-if="has_error">
                                                <div class="col-12" v-for="error, field in errors" v-bind:key="field">
                                                    <div class="alert alert-danger text-danger mb-2">
                                                        <p> {{ error[0] }} </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group col-md-12">
                                                <label>Brand Name</label>
                                                <input class="form-control" v-model="record.name"/>
                                            </div>
                                        </div>

                                        <div class="modal-footer bg-light justify-content-end">
                                            <button class="btn btn-primary float-right">
                                                <em class="icon ni ni-save"></em>
                                                <span> Save Details </span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <!-- Modal -->
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Block head -->
        </div>

        <!-- Block -->
        <div class="ng-block">
            <!-- Processing -->
            <div class="card card-bordered loading" v-if="processing">
                <div class="justify-content-center text-center">
                    <div class="spinner-grow text-primary m-3" role="status">
                        <span class="sr-only">Processing Data...</span>
                    </div>
                    <h6 class="mb-4">Processing Data...</h6>
                </div>
            </div>
            <!-- Processing -->
                
            <div class="card card-bordered" v-else>
                <data-table :headers="headers" :records="records.data" @delete="deleteRecord">
                    <!-- View/Edit Modal Title -->
                    <template #title="scope">
                        Brand: {{ scope.record.name }}
                    </template>
                    <!-- View/Edit Modal Title -->
                    <!-- View Modal -->
                    <template #details="scope">
                        <table class="table pmd-table table-orders">
                            <tbody class="tb-odr-body">
                                <tr>
                                    <td> <b>Brand Name:</b> </td>
                                    <td> {{ scope.record.name }} </td>
                                </tr>
                                <tr>
                                    <td> <b>Created On:</b> </td>
                                    <td>
                                        {{ moment(scope.record.created_at).format("DD-MM-YYYY") }}
                                        at {{ moment(scope.record.created_at).format("hh:mm a") }}
                                    </td>
                                </tr>
                                <tr>
                                    <td> <b>Last Updated On:</b> </td>
                                    <td>
                                        {{ moment(scope.record.updated_at).format("DD-MM-YYYY") }}
                                        at {{ moment(scope.record.updated_at).format("hh:mm a") }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <!-- View Modal -->
                    <!-- Edit Modal -->
                    <template #form="scope">
                        <form class="form row" @submit.prevent="updateRecord(scope.record)">
                            <div class="form-group col-md-12">
                                <label>Name</label>
                                <input class="form-control" v-model="scope.record.name" />
                            </div>
                            <div class="form-group col-md-12">
                                <button class="btn btn-primary float-right">
                                    <em class="icon ni ni-save"></em>
                                    <span> Update {{ scope.record.name }} </span>
                                </button>
                            </div>
                        </form>
                    </template>
                    <!-- Edit Modal -->
                </data-table>
            </div>

            <paginate :data="records" @changed="fetchRecords" v-if="records.data.length"/>
        </div>
        <!-- Block -->
    </div>
</template>

<script lang="ts">
import http from "../../../../../common/services/http";
import { defineComponent, ref, reactive, onMounted } from "vue";
import NgongVegBanner from "@/components/NgongVegBanner.vue";
import moment from "moment";

export default defineComponent({
    components: { NgongVegBanner },
    setup(props, ctx) {
        const search = ref("");
        const processing = ref(false);
        const created = ref(false);
        const updated = ref(false);
        const has_error = ref(false);
        const errors = ref();
        const headers = {
            name: "Name",
        };
        const records = ref({
            data: []
        });
        const record = reactive({
            name: "",
        });

        function searchRecords(event: any) {
            processing.value = true;
            http.get(`/api/brands?s=${search.value}`).then(res => {
                records.value = res.data;
                processing.value = false;
            });
        }

        function fetchRecords(page = 1) {
            processing.value = true;
            http.get(`/api/brands?page=${page}`).then(res => {
                records.value = res.data;
                processing.value = false;
            })
        }

        function createRecord() {
            http.post("api/brands", record).then(res => {
                if (res.data.success) {
                    created.value = true;

                    record.name = "";
                }
            }).finally(() => {
                document.getElementById("hideNewForm")?.click();
                fetchRecords();
            }).catch(error => {
                has_error.value = true;
                errors.value = error.response.data.errors;
            });
        }

        function updateRecord(record: any) {
            record._method = "PUT";
            http.post(`api/brands/${record.id}`, record).then(res => {
                if (res.data.success) {
                    updated.value = true;
                }
            }).finally(() => {
                // document.getElementById(`hideEditForm-${record.id}`)?.click();
                // fetchRecords();
                window.location.reload();
            });
        }

        function deleteRecord(id: any) {
            http.post(`/api/brands/${id}`, {_method: "DELETE"}).then(res => {
                fetchRecords();
            });
        }

        onMounted(() => {
            fetchRecords();
        });

        return {
            moment,
            search,
            processing,
            created,
            updated,
            has_error,
            errors,
            headers,
            records,
            record,
            searchRecords,
            fetchRecords,
            createRecord,
            updateRecord,
            deleteRecord,
        };
    },
});
</script>
